module.exports = __webpack_public_path__ + "static/media/fimi.7df3cbbe.woff";